
class StickyBar extends HTMLElement {
    constructor() {
      super();
      this.target = document.querySelector(this.dataset.target);
      this.ADDITIONAL_OFFSET = Number(this.dataset.offset) || 0;
      this.toggleSticky = this.toggleSticky.bind(this);
  
      window.addEventListener('scroll', this.toggleSticky);
    }
  
    toggleSticky() {
      const targetTop = this.target ? this.target.getBoundingClientRect().top + window.pageYOffset : 0;
      const targetHeight = this.target.dataset.height ? this.target.offsetHeight + this.ADDITIONAL_OFFSET : 0;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      const header = document.querySelector('.section-header');
      const footer = document.querySelector('footer.footer');
  
      if (!(scrollTop >= targetTop + targetHeight 
              && scrollTop <= footer.offsetTop - ( footer.offsetHeight / 2 ) )) {
        this.removeAttribute('is-sticky');
      } else {
        if(header.classList.contains('shopify-section-header-sticky')) this.setAttribute('is-sticky', '');
      }    
      
    }  
  
    disconnectedCallback() {
      window.removeEventListener('scroll', this.toggleSticky);
    }
  
    static get observedAttributes() {
      return ['data-offset'];
    }
  
    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'data-offset') {
        this.ADDITIONAL_OFFSET = Number(newValue) || 0;
      }
    }
  }

  window.addEventListener('load', function () {
    customElements.define('sticky-bar', StickyBar);
  })